module.exports = __webpack_public_path__ + "img/vinqlo_logo.0851c3d3.jpg";